import {Button} from '@material-ui/core';
import ChecksDrawer from 'Agent/Claims/components/ChecksDrawer';
import {
  changeClaimChecks,
  changeClaimFilters,
  EmptyClaimFilter,
  getClaimChecks,
  getClaims,
} from 'Agent/Claims/ducks/claim';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import {Empty} from 'Core/models/Async';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RouteComponentProps} from 'react-router';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import PagedView from 'Shared/components/PagedView/PagedView';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {toFormattedDate} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';

type ClaimProps = {
  selectedAgency: AgencyFilters;
} & RouteComponentProps<{policyNumber: string}>;

export const Claims = (props: ClaimProps) => {
  const dispatch = useDispatch();

  useBreadcrumbs('Claims', props.match.url);
  const {claims, filter} = useSelector(mapStateToProps);
  const {selectedAgency} = props;
  const {currentAgentNumbers} = useSelector((state: ReducerState) => state.user.profile);
  const [selectedClaimNumber, setSelectedClaimNumber] = useState('');

  useEffect(() => {
    dispatch(
      getClaims(
        currentAgentNumbers,
        selectedAgency.isNewYork,
        selectedAgency.encryptedIdentifier,
        props.match.params.policyNumber,
        undefined,
        filter
      )
    );
  }, [filter]);

  useEffect(
    () => () => {
      dispatch(changeClaimFilters(EmptyClaimFilter));
      dispatch(changeClaimChecks(new Empty()));
    },
    []
  );

  return (
    <>
      <PagedView
        pagedViewKey="claims"
        loadMore={page =>
          dispatch(
            getClaims(
              currentAgentNumbers,
              selectedAgency.isNewYork,
              selectedAgency.encryptedIdentifier,
              props.match.params.policyNumber,
              page,
              filter
            )
          )
        }
        data={claims}
      >
        {columnProps => (
          <>
            <Column {...columnProps} title="Claim Number" default>
              {claim => claim.maskedClaimNumber}
            </Column>
            <Column {...columnProps} title="Received Date" default>
              {claim => toFormattedDate(claim.claimReceiptDate)}
            </Column>
            <Column {...columnProps} title="Claimant" default>
              {claim => claim.claimantName}
            </Column>
            <Column {...columnProps} title="Service From Date" default>
              {claim => toFormattedDate(claim.serviceFromDate)}
            </Column>
            <Column {...columnProps} title="Service Through Date" default>
              {claim => toFormattedDate(claim.serviceThroughDate)}
            </Column>
            <Column {...columnProps} title="Total Paid Amount" default>
              {claim => toMoneyValue(claim.totalPaidAmount)}
            </Column>
            <Column {...columnProps} title="Status" default>
              {claim => claim.claimStatus}
            </Column>
            <Column {...columnProps} title="" isActions default>
              {claim =>
                claim.hasChecks ? (
                  <Button
                    color="primary"
                    onClick={() => {
                      dispatch(getClaimChecks(claim, selectedAgency.encryptedIdentifier));
                      setSelectedClaimNumber(claim.maskedClaimNumber!);
                    }}
                  >
                    View Checks
                  </Button>
                ) : (
                  <em>No Checks Available</em>
                )
              }
            </Column>
          </>
        )}
      </PagedView>
      <ChecksDrawer
        claimNumber={selectedClaimNumber}
        open={Boolean(selectedClaimNumber)}
        onClose={() => {
          dispatch(changeClaimChecks(new Empty()));
          setSelectedClaimNumber('');
        }}
      />
    </>
  );
};

const mapStateToProps = (state: ReducerState) => ({
  claims: state.claim.claims,
  filter: state.claim.claimsFilter,
});

export default Claims;
